<script setup>
import { onBeforeMount, ref, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { proxy } = getCurrentInstance();
const store = useStore();
const { t } = useI18n();
const list = ref([]);

onBeforeMount(() => {
  proxy.axios
    .get(proxy.api_notices)
    .then((response) => {
      list.value = response.data.list;
    });
});
</script>

<template>
  <div class="col-lg-6 ps-5 pb-5">
    <div class="wptb-heading">
      <div class="row">
        <div class="col-md-10">
          <div class="wptb-item--inner">
            <h6 class="wptb-item--subtitle">{{ t('board.notice.subtitle') }}</h6>
            <h2 class="wptb-item--title">
              {{ t('board.notice.title') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="wptb-accordion wptb-accordion1 wow fadeInUp">
      <div
        class="wptb--item"
        v-for="(item, index) in list.slice(0, 4)"
        :key="index"
      >
        <h6 class="wptb-item-title">
          <span>
            <span class="wptb-item--number">Q{{ index + 1 }}</span>
            {{ item.title.substring(0, 25) }}
          </span>
          <i class="bi bi-chevron-down"></i>
        </h6>
        <div class="wptb-item--content">{{ item.content.replace("\\n", " ") || "" }}</div>
      </div>
      <div class="wptb-item--button">
        <button class="btn" @click="store.dispatch('showHomePopup', { open: true, tab: 'notice' })">
          <span class="btn-readmore--text">
            {{ t('board.notice.viewMore') }} <i class="bi bi-chevron-double-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
